import api from './api';

interface CurrentUserResponse {
  id: string;
  name: string;
  email: string;
  role: string;
  businessUnitId?: string;
  roles?: string[]; // Support both single role and roles array
}

interface ClaimsDebugResponse {
  isAuthenticated: boolean;
  authenticationType: string;
  name: string;
  claims: Array<{ type: string; value: string }>;
  isInAdminRole: boolean;
  isInUserRole: boolean;
  isInManagerRole: boolean;
}

export const authService = {
  getCurrentUser: () => api.get<CurrentUserResponse>('/auth/me'),
  
  healthCheck: () => api.get('/auth/health'),
  
  // Debug endpoint to view all claims
  getClaims: () => api.get<ClaimsDebugResponse>('/auth/claims'),
};
